// extracted by mini-css-extract-plugin
export var label = "_h6-2";
export var slideContainer = "_h6-0";
export var slider = "_h6-1";